import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackground2 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M497.195 198.78C474.072 179.723 444.452 173.77 415.672 165.11C422.046 145.83 428.315 126.592 431.924 107.442C440.024 46.3036 368.644 75.6539 300.579 94.8406C280.199 70.1883 261.868 42.5855 239.923 20.6816C201.975 -13.2787 184.484 32.2973 166.889 86.9689C145.167 80.5543 123.138 74.985 101.292 68.9697C100.529 68.7571 99.7204 68.5808 98.9374 68.4564C25.1207 57.0377 84.4126 165.323 93.7985 212.392C68.9751 231.138 45.6971 252.052 21.9316 272.234C21.3249 272.747 20.7233 273.313 20.184 273.893C-14.8497 311.369 32.1368 328.757 79.3204 342.053C54.3674 421.579 29.7048 471.718 200.808 409.024C201.897 408.583 202.986 408.163 204.07 407.764C271.332 477.894 301.206 573.376 346.455 426.743C367.701 433.345 389.076 438.421 410.834 437.633C420.542 437.281 428.776 430.015 429.663 420.339C433.117 382.49 413.277 347.881 405.208 310.711C437.592 282.434 478.153 260.209 500.903 224.076C506.078 215.856 504.714 204.961 497.216 198.78H497.195Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBackground2);
export default ForwardRef;
